import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-image-full-download-app-links.component.scss';
var BannerMidPageImageFullDownloadAppLinks = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageImageFullDownloadAppLinks, _super);
    function BannerMidPageImageFullDownloadAppLinks(element) {
        return _super.call(this, element) || this;
    }
    BannerMidPageImageFullDownloadAppLinks.prototype.init = function () {
        if (this.element.querySelector('.banner-mid-page-image-full-download-app-links__button')) {
            this.buttonContainers = Array.from(this.element.querySelectorAll('.banner-mid-page-image-full-download-app-links__button'));
            this.check();
        }
        // if(this.element.querySelector('.js-qr-image')) {
        // 	this.containerImage = this.element.querySelector('.js-qr-image');
        // }
        // if(this.element.getAttribute('data-qr-image-android')) {
        // 	this.attrAndroid = this.element.getAttribute('data-qr-image-android');
        // }
        // if(this.element.getAttribute('data-qr-image-ios')) {
        // 	this.attrIos = this.element.getAttribute('data-qr-image-ios');
        // }
        // if(this.element.getAttribute('data-qr-image-huawei')) {
        // 	this.attrHuawei = this.element.getAttribute('data-qr-image-huawei');
        // }
        // this.assignImage();
    };
    BannerMidPageImageFullDownloadAppLinks.prototype.bindEvents = function () {
    };
    BannerMidPageImageFullDownloadAppLinks.prototype.assignImage = function () {
        if (this.isIosDevice()) {
            this.containerImage.setAttribute('src', this.attrIos);
        }
        else if (this.isHauweiDevice()) {
            this.containerImage.setAttribute('src', this.attrHuawei);
        }
        else if (this.isAndroidDevice()) {
            this.containerImage.setAttribute('src', this.attrAndroid);
        }
        else {
            this.containerImage.setAttribute('src', this.attrAndroid);
        }
    };
    BannerMidPageImageFullDownloadAppLinks.prototype.check = function () {
        var _this = this;
        this.buttonContainers.map(function (container) {
            var button = container.querySelector('a');
            if (button.hasAttribute('downloadappandroid') ||
                button.hasAttribute('downloadappios') ||
                button.hasAttribute('downloadapphuawei') ||
                button.hasAttribute('downloadappdesktop')) {
                container.classList.add('d-none');
                if (_this.isIosDevice()) {
                    if (button.hasAttribute('downloadappios')) {
                        container.classList.remove('d-none');
                    }
                }
                else if (_this.isHauweiDevice()) {
                    if (button.hasAttribute('downloadapphuawei')) {
                        container.classList.remove('d-none');
                    }
                }
                else if (_this.isAndroidDevice()) {
                    if (button.hasAttribute('downloadappandroid')) {
                        container.classList.remove('d-none');
                    }
                }
                else {
                    if (button.hasAttribute('downloadappdesktop')) {
                        container.classList.remove('d-none');
                    }
                }
            }
        });
    };
    BannerMidPageImageFullDownloadAppLinks.prototype.isIosDevice = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /iPad|iPhone|iPod/i.test(userAgent);
    };
    BannerMidPageImageFullDownloadAppLinks.prototype.isAndroidDevice = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android/i.test(userAgent);
    };
    BannerMidPageImageFullDownloadAppLinks.prototype.isHauweiDevice = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /huawei/i.test(userAgent);
    };
    return BannerMidPageImageFullDownloadAppLinks;
}(Base));
export { BannerMidPageImageFullDownloadAppLinks };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-image-full-download-app-links/banner-mid-page-image-full-download-app-links.component.ts
// module id = 758
// module chunks = 0